import type { CoreConsent } from "@tandemdiabetes/sugarmate-api-react-client"
import styles from "./ConsentLabel.module.scss"
import { ConsentTextWithLinks } from "./ConsentTextWithLinks"

type Props = {
  consent: CoreConsent;
}

export const ConsentLabel = ({ consent }: Props) => (
  <>
    {consent.inlineContent && (
      <div className={styles.consentLabel}>
        <div className={styles.consentLabelSubTitle}>
          {consent.inlineContent.title}
        </div>
        <div>
          {consent.inlineContent.text}
        </div>
      </div>
    )}
    {!consent.inlineContent && consent.content && (
      <ConsentTextWithLinks
        text={consent.content.text || ""}
        links={consent.content.links || {}}
      />
    )}
  </>
)
